import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './grid-form-button.css'

const GridFormButton = ({ name, secondary, onClick }) => (
  <button
    styleName={secondary ? 'button-secondary' : 'button-primary'}
    type="button"
    onClick={onClick}
  >
    {name}
  </button>
)

GridFormButton.propTypes = {
  name: PropTypes.string,
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
}

export default CSSModules(GridFormButton, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-button/grid-form-button.js
 **/